import { PaymentPlanLimitAPIResponse } from 'Components/ManageMerchant/Components/MerchantDetails/types';
import getFetchOptions from 'utils/getFetchOptions';

import { handleResponse } from '../utils';
import { AdministerMerchantRequest } from './merchants.administer.types';
import { AddNewPaymentProfileResponse, PaymentProfile, PaymentProfileType } from './merchants.paymentprofiles.types';
import {
  AnyMerchant,
  CreateMerchantPersonRequest,
  MerchantGeneralSettingsResponse,
  MerchantPerson,
  MerchantStatusResponse,
  PayoutStatusUpdateRequest,
  PutMerchantGeneralSettingsRequest,
  UpdateMerchantBusinessProfileRequest,
  handleAnyMerchant,
  kybResponse,
} from './merchants.types';

export const getMerchant = async (apiAprilBaseUri: string, merchantId: string): Promise<AnyMerchant> => {
  const options = await getFetchOptions();
  return await fetch(`${apiAprilBaseUri}/merchants/${merchantId}`, options)
    .then(handleResponse)
    .then(handleAnyMerchant);
};

export const getMerchantGeneralSettings = async (
  apiAprilBaseUri: string,
  merchantId: string,
): Promise<MerchantGeneralSettingsResponse> => {
  const options = await getFetchOptions('GET');
  return await fetch(`${apiAprilBaseUri}/merchants/${merchantId}/settings`, options).then(handleResponse);
};

export const putMerchantGeneralSettings = async (
  apiAprilBaseUri: string,
  merchantId: string,
  payload: PutMerchantGeneralSettingsRequest,
): Promise<void> => {
  const options = await getFetchOptions('PUT', JSON.stringify(payload));
  return await fetch(`${apiAprilBaseUri}/merchants/${merchantId}/settings`, options).then(handleResponse);
};

export const getMerchantPaymentProfiles = async (
  apiBaseUri: string,
  merchantId: string,
): Promise<Array<PaymentProfile>> => {
  const options = await getFetchOptions('GET');
  return await fetch(`${apiBaseUri}/onboarding/payment-profiles/${merchantId}`, options).then(handleResponse);
};

export const addNewPaymentProfile = async (
  apiBaseUri: string,
  merchantId: string,
  profileType: PaymentProfileType,
): Promise<AddNewPaymentProfileResponse> => {
  const payload = {
    profileType,
  };
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiBaseUri}/onboarding/payment-profiles/${merchantId}`, options).then(handleResponse);
};

export const activatePaymentProfile = async (
  apiBaseUri: string,
  merchantId: string,
  profileId: string,
): Promise<void> => {
  const payload = {
    profileId,
  };
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiBaseUri}/onboarding/payment-profiles/${merchantId}/activate`, options).then(handleResponse);
};

export const updateMerchantPayoutStatus = async (
  apiBaseUri: string,
  merchantId: string,
  payload: PayoutStatusUpdateRequest,
): Promise<void> => {
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiBaseUri}/admin/merchants/${merchantId}/settings/payout-status`, options).then(
    handleResponse,
  );
};

export const getMerchantStatus = async (apiBaseUri: string, merchantId: string): Promise<MerchantStatusResponse> => {
  const options = await getFetchOptions('GET');
  return await fetch(`${apiBaseUri}/merchants/${merchantId}/status`, options).then(handleResponse);
};

export const AdministerMerchant = async (
  apiAprilBaseUri: string,
  merchantId: string,
  payload: AdministerMerchantRequest,
): Promise<AnyMerchant> => {
  const options = await getFetchOptions('PATCH', JSON.stringify(payload));
  return await fetch(`${apiAprilBaseUri}/merchants/enterprise/${merchantId}`, options)
    .then(handleResponse)
    .then(handleAnyMerchant);
};

export const getMerchantPayPlanSettings = async (
  apiBaseUri: string,
  merchantId: string,
): Promise<PaymentPlanLimitAPIResponse> => {
  const options = await getFetchOptions('GET');
  return await fetch(`${apiBaseUri}/merchants/${merchantId}/settings/payplan`, options).then(handleResponse);
};

export const getMerchantPersons = async (apiBaseUri: string, merchantId: string): Promise<Array<MerchantPerson>> => {
  const options = await getFetchOptions('GET');
  return await fetch(`${apiBaseUri}/onboarding/${merchantId}/person`, options).then(handleResponse);
};

export const createMerchantPerson = async (
  apiBaseUri: string,
  merchantId: string,
  payload: CreateMerchantPersonRequest,
): Promise<string> => {
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiBaseUri}/onboarding/${merchantId}/person`, options).then(handleResponse);
};

export const updateMerchantBusinessProfile = async (
  apiBaseUri: string,
  merchantId: string,
  payload: UpdateMerchantBusinessProfileRequest,
): Promise<void> => {
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiBaseUri}/onboarding/${merchantId}`, options).then(handleResponse);
};

export const kybMerchant = async (apiBaseUri: string, merchantId: string): Promise<kybResponse> => {
  const options = await getFetchOptions('POST');
  return await fetch(`${apiBaseUri}/admin/merchants/${merchantId}/kyb`, options).then(handleResponse);
};
